import { ButtonsGroupLabelled } from 'components/shared/ButtonsGroup/buttons-group-labelled';
import { useTranslateForm } from 'hooks/use-translate-payoff';
import { RadioButtonsFieldMetadata } from 'models/forms/fields/RadioButtonsFieldMetadata';
import { useCallback, useMemo } from 'react';
import { ErrorWrapper } from 'routes/essential-workspace/components/form/error-wrapper';
import { useFormErrors } from 'routes/essential-workspace/components/form/use-form-errors';
import { useFormFieldData } from 'routes/essential-workspace/components/form/use-form-field-data';

export function RadioButtonsField({ id, translationKey, isReadOnly, availableItems }: RadioButtonsFieldMetadata) {
  const [value, setFormData] = useFormFieldData<Nullable<string>>(id);

  const { getFieldError } = useFormErrors();
  const fieldError = getFieldError(id);

  const { translateLabel } = useTranslateForm();
  const label = translateLabel(translationKey ?? id);

  const options = useMemo<string[]>(() => availableItems.map(item => item.value), [availableItems]);

  const handleOnValueChanged = useCallback(
    (value: readonly string[]) => {
      setFormData(value[0]);
    },
    [setFormData],
  );

  return (
    <ErrorWrapper error={fieldError}>
      <ButtonsGroupLabelled
        id={id}
        label={label}
        options={options}
        value={value}
        onValueChanged={handleOnValueChanged}
        isReadOnly={isReadOnly}
        isInvalid={fieldError?.severity === 'Error'}
        isHighlighted={fieldError?.severity === 'Warning'}
      />
    </ErrorWrapper>
  );
}
